import api from "../apiSetup/apiCall";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const postPopupAdd = createAsyncThunk("popup/postPopupAdd", async (payload) => {
  try {
      const response = await api.post("popup/add/", payload);
      return response.data;
  } catch (error) {
      console.error("Error post popup/add/:", error);
      return error.response.data;
  }
});

const PopupAddSlice = createSlice({
    name: "popupAdd",
    initialState: { data: null, error: null, isLoading: false},
    reducers: {},
    extraReducers: (builder) => {builder
        .addCase(postPopupAdd.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(postPopupAdd.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        })
        .addCase(postPopupAdd.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload.message;
        });
    },
});

export default PopupAddSlice.reducer;
